import tinycolor from 'tinycolor2'

const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
const colorRegex = /^#?(?<r>[a-f\d]{2})(?<g>[a-f\d]{2})(?<b>[a-f\d]{2})(?<a>[a-f\d]{2})?$/i

export function ensureHash (color?: string) {
  if (!color) return ''
  return color.startsWith('#') ? color : `#${color}`
}

export function dropAlphaIfFull (hex: string) {
  return hex?.length === 8 && hex.toLowerCase().endsWith('ff') ? hex.slice(0, 6) : hex
}

// Returns true if the color is well conformed.
export function isValidColor (color?: string) {
  return color && (colorRegex.test(color) || shorthandRegex.test(color))
}

// Calculates the contrast ratio between two CSS color's relative luminances based on this definition:
// https://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
//
// Contrast ratios can range from 1 to 21 (commonly written 1:1 to 21:1)
export function getContrastRatio (colorA: string, colorB: string) {
  return tinycolor.readability(colorA, colorB)
}
